module.exports = __webpack_public_path__ + "prod/1.42.2/img/stay-bj.a8a10b20.png";